/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CarefinityRoles } from '../../models/carefinity-roles';

export interface RolesGetCarefinityRoles$Params {
  PracticeId?: string | null;
  roleId?: number;
}

export function rolesGetCarefinityRoles(http: HttpClient, rootUrl: string, params?: RolesGetCarefinityRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<CarefinityRoles>> {
  const rb = new RequestBuilder(rootUrl, rolesGetCarefinityRoles.PATH, 'get');
  if (params) {
    rb.query('PracticeId', params.PracticeId, {});
    rb.query('roleId', params.roleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CarefinityRoles>;
    })
  );
}

rolesGetCarefinityRoles.PATH = '/roles/getCarefinityroles';
